/**
 * @fileoverview Task list column visibility persistence (MOR-707)
 *
 * Split out of `task-columns-menu.tsx` (react-refresh/only-export-components)
 * — the hosting surface owns the visible-set state, persisted to
 * `localStorage` via these helpers.
 */

import { TASK_LIST_COLUMNS } from "./task-list-view.helpers";

const STORAGE_KEY = "task-list-visible-cols";

/** Load the persisted visible-column set (default-visible set as fallback). */
export function loadVisibleColumns(): Set<string> {
  const defaults = new Set(
    TASK_LIST_COLUMNS.filter((c) => c.defaultVisible).map((c) => c.key),
  );
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return defaults;
    const keys = JSON.parse(raw) as string[];
    const known = new Set(TASK_LIST_COLUMNS.map((c) => c.key));
    const set = new Set(keys.filter((k) => known.has(k)));
    // Title and Job are always on (Job only renders in the cross-job view).
    set.add("title");
    set.add("job");
    return set.size > 1 ? set : defaults;
  } catch {
    return defaults;
  }
}

export function persistVisibleColumns(cols: ReadonlySet<string>): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...cols]));
  } catch {
    // localStorage unavailable (private mode) — visibility just won't persist.
  }
}
